import Switch from '@mui/material/Switch';
import { alpha, hexToRgb } from '@mui/system';

import { styled } from 'helpers';

export const StyledSwitch = styled(Switch)`
  padding: 0;
  height: 22px;
  width: 48px;
  border-radius: 100px;

  & .MuiSwitch-switchBase {
    top: 2px;
    padding-left: 2px;
    padding-top: 0;
    padding-bottom: 0;

    &:hover {
      background-color: unset;
    }

    &.Mui-checked {
      transform: translateX(28px);
      padding-right: 2px;
      padding-left: 0;
    }
  }

  /* the actual input element that responds to "onClick" -- all styles are focused on keeping the input clickable so it doesnt have any "dead zones" that dont respond to clicks */
  & .MuiSwitch-input {
    left: -125%;
    top: -4px;
    height: 140%;
  }

  & .MuiSwitch-switchBase.Mui-checked .MuiSwitch-input {
    left: -150%;
  }

  /* Thumb (circle) styles */
  & .MuiSwitch-thumb {
    width: 18px;
    height: 18px;
    color: ${({ theme }) => theme.palette.common.white};

    box-shadow: -1px -0.4px 1px 0px rgba(84, 104, 127, 0.12), 1px 1px 2px 0px rgba(84, 104, 127, 0.16);
  }
  .Mui-disabled .MuiSwitch-thumb {
    box-shadow: -1px -0.4px 1px 0px rgba(84, 104, 127, 0.01), 1px 1px 2px 0px rgba(84, 104, 127, 0.01),
      0px 0px 12px 0px rgba(169, 179, 190, 0.12) inset;
  }
  .Mui-checked.Mui-disabled .MuiSwitch-thumb {
    box-shadow: -1px -0.4px 1px 0px rgba(84, 104, 127, 0.01), 1px 1px 2px 0px rgba(84, 104, 127, 0.01),
      0px 0px 6px 0px rgba(169, 179, 190, 0.14) inset;
  }

  /* track styles */
  &&& .MuiSwitch-track {
    opacity: 1;
    border-radius: 100px;
  }

  & .MuiSwitch-track {
    background-color: ${({ theme }) => theme.palette.blueGrey['A300']};
  }

  &.hovered-switch .MuiSwitch-track {
    box-shadow: 0px 0px 4px rgba(34, 38, 72, 0.26) inset;
  }

  &.hovered-switch .Mui-checked + .MuiSwitch-track {
    box-shadow: 0px 0px 4px 0px rgba(34, 38, 72, 0.56) inset;
  }

  & .Mui-checked + .MuiSwitch-track {
    background-color: ${({ theme }) => theme.palette.primary.main};
    box-shadow: 0px 0px 4px 0px rgba(84, 104, 127, 0.18) inset;
  }

  .Mui-disabled + .MuiSwitch-track {
    background-color: ${({ theme }) => `${alpha(hexToRgb(theme.palette.blueGrey['A300']), 0.32)}`};
    box-shadow: 0px 0px 6px 0px rgba(237, 239, 244, 0.6) inset;
  }

  & .Mui-checked.Mui-disabled + .MuiSwitch-track {
    background-color: ${({ theme }) => `${alpha(hexToRgb(theme.palette.primary.main), 0.28)}`};
    box-shadow: 0px 0px 6px 0px rgba(237, 239, 244, 0.14) inset;
  }
`;

StyledSwitch.displayName = 'Switch';
